import { Container } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { myVideosAction } from "../../store/actions/video";
import NoVideo from "./components/NoVideo";
import Videos from "./components/Videos";

const MyVideo = () => {
  const dispatch = useDispatch();

  const [searchText, setSearchText] = useState();
  const searchTermChanged = (e) => setSearchText(e?.target?.value);

  const myVideo = useSelector((s) => s.myVideo.data);
  const loading = useSelector((s) => s.myVideo.loading);

  const fetchMyVideos = useCallback(
    ({ page, searchText, categoryId, videoId }) => {
      myVideosAction({
        page,
        limit: 12,
        videoId,
        text: searchText || undefined,
        categoryId,
      })(dispatch);
    },
    [dispatch]
  );

  useEffect(() => {
    return fetchMyVideos({ page: 1 });
  }, [fetchMyVideos]);

  const scrolled = useCallback(
    (e) => {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollTop + clientHeight + 50 >= scrollHeight) {
        fetchMyVideos({
          next: true,
          limit: 5,
          searchText,
        });
      }
    },
    [fetchMyVideos, searchText]
  );

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchMyVideos({ page: 1, searchText });
    }, 700);

    return () => clearTimeout(delayDebounceFn);
  }, [searchText, fetchMyVideos]);

  return (
    <>
      <Container maxWidth={"xl"} sx={{ mt: 3 }}>
        {myVideo.length <= 0 && !loading && <NoVideo />}
        {myVideo.length > 0 && (
          <Videos searchTermChanged={searchTermChanged} scrolled={scrolled} />
        )}
      </Container>
    </>
  );
};

export default MyVideo;
